import { atom } from 'recoil';
import { LayoutState } from '../types/layoutState';

export const layoutStateAtom = atom<LayoutState>({
  key: 'layout',
  default: undefined,
});
